let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eLewR")).then(() => parcelRequire('79ZX9'));